import React from 'react'
import { AiFillCheckCircle } from 'react-icons/ai';

const Placements: React.FC = () => {
  return (
    <div className="flex justify-center bg-white text-[#555] font-Poppins rounded-lg p-8 pb-16 flex-col shadow-[0px_4px_16px_0px_rgba(24,119,242,0.08)] ">
      <div className="flex gap-2 items-center">
        <AiFillCheckCircle className='fill-green-500'/>
        <h1 className='font-semibold text-lg'>Placements</h1>
      </div>

      <div className="mt-8 pl-[10px] pr-[238px]">
        <div className="flex">
          <input 
            type='radio' 
            id='r1' 
            className='accent-midGreen w-[18.5px] mr-1 cursor-pointer'
            // checked={radio1}
            // onChange={handleRadio1Change}
          />
          <label htmlFor="r1" className='text-sm font-semibold mr-3'>Advantage+ placements (recommended)</label>
        </div>
        <p id='r1' className='text-xs font-normal mt-2 ml-[22px]'>
          Use advantage+ placements to maximize your budget
          and help show your ads to more people.
          Orokii’s delivery system will allocate your ads budget
          across multiple placements based on
          where thy are likely to perform best
        </p>

        <div className="mt-5 flex">
          <input 
            type='radio' 
            id='r2' 
            className='accent-midGreen w-[18.5px] mr-1 cursor-pointer bg-CoolGrey'
            // checked={radio1}
            // onChange={handleRadio1Change}
          />
          <label htmlFor="r2" className='text-sm font-semibold mr-3'>Manual placements</label>
        </div>
        <p id='r2' className='text-xs font-normal mt-2 ml-[22px]'>
          Manually choose the place to show your ad.
          The more placements you select, the more
          opportunities you’ll have to reach your target audience
          and achieve your business goals.
        </p>
        
      </div>
      <h1 className='font-semibold text-lg mt-8'>Devices</h1>
      <h4 className='font-sm font-normal mt-1'>All Devices</h4>
      <div className="mt-8 grid gap-6">
        <h1 className='font-semibold text-lg'>Platforms</h1>
        <label className="flex gap-3 items-center font-normal text-black text-sm">
          <input 
            type='checkbox' 
            className='accent-midGreen h-7 w-7'
            // checked={checkbox1} 
            // onChange={handleCheckbox1Change}
          />EcoBook
        </label>
        <label className="flex gap-3 items-center font-normal text-black text-sm">
          <input 
            type='checkbox' 
            className='accent-midGreen h-7 w-7'
            // checked={checkbox1} 
            // onChange={handleCheckbox1Change}
          />Lorem Ipsum
        </label>
      </div>
    </div>
  )
}

export default Placements;